import { Product } from '../../types';

export const ringSeriesProducts: Product[] = [
  // LA103 Series
  {
    id: "bt-ring-swt001003s",
    name: "Ring Series Terminal - LA103 Small Hole (SWT001003S)",
    slug: "ring-terminal-la103-small-hole-swt001003s",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA103 ring terminal with small hole (3.20mm ID) for 1.50-2.20 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001003S",
    featured: true,
    specifications: {
      "OD Ø": "7.00 mm",
      "ID Ø": "3.20 mm",
      "Cable Size SQ. MM": "1.50-2.20",
      "Description": "LA103 Small Hole",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001003S.jpg"],
    tags: ["terminal", "ring", "brass", "la103"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt001003m",
    name: "Ring Series Terminal - LA103 Medium Hole (SWT001003M)",
    slug: "ring-terminal-la103-medium-hole-swt001003m",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA103 ring terminal with medium hole (3.70mm ID) for 1.50-2.20 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001003M",
    specifications: {
      "OD Ø": "7.00 mm",
      "ID Ø": "3.70 mm",
      "Cable Size SQ. MM": "1.50-2.20",
      "Description": "LA103 Medium Hole",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001003M.jpg"],
    tags: ["terminal", "ring", "brass", "la103"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt001003b",
    name: "Ring Series Terminal - LA103 Big Hole (SWT001003B)",
    slug: "ring-terminal-la103-big-hole-swt001003b",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA103 ring terminal with big hole (4.20mm ID) for 1.50-2.20 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001003B",
    specifications: {
      "OD Ø": "7.00 mm",
      "ID Ø": "4.20 mm",
      "Cable Size SQ. MM": "1.50-2.20",
      "Description": "LA103 Big Hole",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001003B.jpg"],
    tags: ["terminal", "ring", "brass", "la103"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // LA104 Series
  {
    id: "bt-ring-swt001004s",
    name: "Ring Series Terminal - LA104 Small Hole (SWT001004S)",
    slug: "ring-terminal-la104-small-hole-swt001004s",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA104 ring terminal with small hole (4.50mm ID) for 1.50-2.20 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001004S",
    specifications: {
      "OD Ø": "7.50 mm",
      "ID Ø": "4.50 mm",
      "Cable Size SQ. MM": "1.50-2.20",
      "Description": "LA104 Small Hole",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001004S.jpg"],
    tags: ["terminal", "ring", "brass", "la104"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt001004b",
    name: "Ring Series Terminal - LA104 Big Hole (SWT001004B)",
    slug: "ring-terminal-la104-big-hole-swt001004b",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA104 ring terminal with big hole (5.00mm ID) for 1.50-2.20 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001004B",
    specifications: {
      "OD Ø": "7.50 mm",
      "ID Ø": "5.00 mm",
      "Cable Size SQ. MM": "1.50-2.20",
      "Description": "LA104 Big Hole",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001004B.jpg"],
    tags: ["terminal", "ring", "brass", "la104"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // LA105, LA106
  {
    id: "bt-ring-swt001005",
    name: "Ring Series Terminal - LA105 (SWT001005)",
    slug: "ring-terminal-la105-swt001005",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA105 ring terminal for 2.00-3.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001005",
    specifications: {
      "OD Ø": "10.00 mm",
      "ID Ø": "5.20 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "LA105",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001005.jpg"],
    tags: ["terminal", "ring", "brass", "la105"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt001006",
    name: "Ring Series Terminal - LA106 (SWT001006)",
    slug: "ring-terminal-la106-swt001006",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA106 ring terminal for 2.00-3.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001006",
    specifications: {
      "OD Ø": "12.00 mm",
      "ID Ø": "6.50 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "LA106",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001006.jpg"],
    tags: ["terminal", "ring", "brass", "la106"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // LA107, LA108, LA111
  {
    id: "bt-ring-swt001007",
    name: "Ring Series Terminal - LA107 (SWT001007)",
    slug: "ring-terminal-la107-swt001007",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA107 ring terminal for 2.00-3.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001007",
    specifications: {
      "OD Ø": "12.00 mm",
      "ID Ø": "7.50 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "LA107",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001007.jpg"],
    tags: ["terminal", "ring", "brass", "la107"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt001008",
    name: "Ring Series Terminal - LA108 (SWT001008)",
    slug: "ring-terminal-la108-swt001008",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA108 ring terminal for 2.00-3.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001008",
    specifications: {
      "OD Ø": "12.05 mm",
      "ID Ø": "8.50 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "LA108",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001008.jpg"],
    tags: ["terminal", "ring", "brass", "la108"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt001111",
    name: "Ring Series Terminal - LA111 (SWT001111)",
    slug: "ring-terminal-la111-swt001111",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA111 ring terminal. High conductivity brass construction.",
    partNumber: "SWT001111",
    specifications: {
      "OD Ø": "16.10 mm",
      "ID Ø": "11.00 mm",
      "Cable Size SQ. MM": "N/A",
      "Description": "LA111",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001111.jpg"],
    tags: ["terminal", "ring", "brass", "la111"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // LA206, LA208
  {
    id: "bt-ring-swt001206",
    name: "Ring Series Terminal - LA206 (SWT001206)",
    slug: "ring-terminal-la206-swt001206",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA206 ring terminal for 2.50-3.50 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001206",
    specifications: {
      "OD Ø": "12.00 mm",
      "ID Ø": "6.50 mm",
      "Cable Size SQ. MM": "2.50-3.50",
      "Description": "LA206",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001206.jpg"],
    tags: ["terminal", "ring", "brass", "la206"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt001208",
    name: "Ring Series Terminal - LA208 (SWT001208)",
    slug: "ring-terminal-la208-swt001208",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA208 ring terminal for 3.20-4.50 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001208",
    specifications: {
      "OD Ø": "16.00 mm",
      "ID Ø": "8.50 mm",
      "Cable Size SQ. MM": "3.20-4.50",
      "Description": "LA208",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1500 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001208.jpg"],
    tags: ["terminal", "ring", "brass", "la208"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // LA306, LA308
  {
    id: "bt-ring-swt001306",
    name: "Ring Series Terminal - LA306 (SWT001306)",
    slug: "ring-terminal-la306-swt001306",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA306 ring terminal for 3.80-4.80 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001306",
    specifications: {
      "OD Ø": "12.00 mm",
      "ID Ø": "6.50 mm",
      "Cable Size SQ. MM": "3.80-4.80",
      "Description": "LA306",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1500 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001306.jpg"],
    tags: ["terminal", "ring", "brass", "la306"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt001308",
    name: "Ring Series Terminal - LA308 (SWT001308)",
    slug: "ring-terminal-la308-swt001308",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "LA308 ring terminal for 4.10-5.10 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT001308",
    specifications: {
      "OD Ø": "16.00 mm",
      "ID Ø": "8.50 mm",
      "Cable Size SQ. MM": "4.10-5.10",
      "Description": "LA308",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT001308.jpg"],
    tags: ["terminal", "ring", "brass", "la308"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // No 2A Series
  {
    id: "bt-ring-swt004021",
    name: "Ring Series Terminal - No 2A Small (SWT004021)",
    slug: "ring-terminal-no-2a-small-swt004021",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 2A Small ring terminal for 2.00-3.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004021",
    specifications: {
      "OD Ø": "8.40 mm",
      "ID Ø": "4.30 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "No 2A Small",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004021.jpg"],
    tags: ["terminal", "ring", "brass", "no-2a"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004023",
    name: "Ring Series Terminal - No 2A (SWT004023)",
    slug: "ring-terminal-no-2a-swt004023",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 2A ring terminal for 2.00-3.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004023",
    specifications: {
      "OD Ø": "8.00 mm",
      "ID Ø": "4.40 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "No 2A",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004023.jpg"],
    tags: ["terminal", "ring", "brass", "no-2a"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004024",
    name: "Ring Series Terminal - No 2A Cross Leg (SWT004024)",
    slug: "ring-terminal-no-2a-cross-leg-swt004024",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 2A Cross Leg ring terminal for 2.80-3.80 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004024",
    specifications: {
      "OD Ø": "8.10 mm",
      "ID Ø": "4.60 mm",
      "Cable Size SQ. MM": "2.80-3.80",
      "Description": "No 2A Cross Leg",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004024.jpg"],
    tags: ["terminal", "ring", "brass", "no-2a", "cross-leg"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004029",
    name: "Ring Series Terminal - No 2A Special Cross Leg (SWT004029)",
    slug: "ring-terminal-no-2a-special-cross-leg-swt004029",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 2A Special Cross Leg ring terminal for 2.80-3.80 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004029",
    specifications: {
      "OD Ø": "7.50 mm",
      "ID Ø": "4.40 mm",
      "Cable Size SQ. MM": "2.80-3.80",
      "Description": "No 2A Special Cross Leg",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004029.jpg"],
    tags: ["terminal", "ring", "brass", "no-2a", "cross-leg"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // No 3A Series
  {
    id: "bt-ring-swt004031",
    name: "Ring Series Terminal - No 3A Small (SWT004031)",
    slug: "ring-terminal-no-3a-small-swt004031",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 3A Small ring terminal for 2.00-3.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004031",
    specifications: {
      "OD Ø": "8.40 mm",
      "ID Ø": "5.30 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "No 3A Small",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004031.jpg"],
    tags: ["terminal", "ring", "brass", "no-3a"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004032",
    name: "Ring Series Terminal - No 3 (SWT004032)",
    slug: "ring-terminal-no-3-swt004032",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 3 ring terminal for 3.00-4.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004032",
    specifications: {
      "OD Ø": "10.50 mm",
      "ID Ø": "5.60 mm",
      "Cable Size SQ. MM": "3.00-4.00",
      "Description": "No 3",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004032.jpg"],
    tags: ["terminal", "ring", "brass", "no-3"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004033",
    name: "Ring Series Terminal - No 3A (SWT004033)",
    slug: "ring-terminal-no-3a-swt004033",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 3A ring terminal for 2.50-3.50 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004033",
    specifications: {
      "OD Ø": "9.00 mm",
      "ID Ø": "5.60 mm",
      "Cable Size SQ. MM": "2.50-3.50",
      "Description": "No 3A",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004033.jpg"],
    tags: ["terminal", "ring", "brass", "no-3a"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004034",
    name: "Ring Series Terminal - No 3A Standard (SWT004034)",
    slug: "ring-terminal-no-3a-standard-swt004034",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 3A Standard ring terminal for 2.50-3.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004034",
    specifications: {
      "OD Ø": "8.90 mm",
      "ID Ø": "5.00 mm",
      "Cable Size SQ. MM": "2.50-3.00",
      "Description": "No 3A Standard",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004034.jpg"],
    tags: ["terminal", "ring", "brass", "no-3a"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004039",
    name: "Ring Series Terminal - No 3A Special (SWT004039)",
    slug: "ring-terminal-no-3a-special-swt004039",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 3A Special ring terminal for 3.50-4.50 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004039",
    specifications: {
      "OD Ø": "9.10 mm",
      "ID Ø": "5.10 mm",
      "Cable Size SQ. MM": "3.50-4.50",
      "Description": "No 3A Special",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004039.jpg"],
    tags: ["terminal", "ring", "brass", "no-3a"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // No 3B
  {
    id: "bt-ring-swt004036",
    name: "Ring Series Terminal - No 3B (SWT004036)",
    slug: "ring-terminal-no-3b-swt004036",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 3B ring terminal for 3.00-4.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004036",
    specifications: {
      "OD Ø": "10.90 mm",
      "ID Ø": "5.60 mm",
      "Cable Size SQ. MM": "3.00-4.00",
      "Description": "No 3B",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004036.jpg"],
    tags: ["terminal", "ring", "brass", "no-3b"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // No 4 Series
  {
    id: "bt-ring-swt004042",
    name: "Ring Series Terminal - No 4 (SWT004042)",
    slug: "ring-terminal-no-4-swt004042",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 4 ring terminal for 3.50-4.50 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004042",
    specifications: {
      "OD Ø": "12.00 mm",
      "ID Ø": "7.50 mm",
      "Cable Size SQ. MM": "3.50-4.50",
      "Description": "No 4",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004042.jpg"],
    tags: ["terminal", "ring", "brass", "no-4"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004043",
    name: "Ring Series Terminal - No 4A (SWT004043)",
    slug: "ring-terminal-no-4a-swt004043",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 4A ring terminal for 3.50-4.50 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004043",
    specifications: {
      "OD Ø": "12.00 mm",
      "ID Ø": "8.00 mm",
      "Cable Size SQ. MM": "3.50-4.50",
      "Description": "No 4A",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004043.jpg"],
    tags: ["terminal", "ring", "brass", "no-4a"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004046",
    name: "Ring Series Terminal - No 4B (SWT004046)",
    slug: "ring-terminal-no-4b-swt004046",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 4B ring terminal for 4.50-5.50 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004046",
    specifications: {
      "OD Ø": "13.10 mm",
      "ID Ø": "7.20 mm",
      "Cable Size SQ. MM": "4.50-5.50",
      "Description": "No 4B",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004046.jpg"],
    tags: ["terminal", "ring", "brass", "no-4b"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004049",
    name: "Ring Series Terminal - No 4B Special (SWT004049)",
    slug: "ring-terminal-no-4b-special-swt004049",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 4B Special ring terminal for 2.50-3.50 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004049",
    specifications: {
      "OD Ø": "12.50 mm",
      "ID Ø": "6.50 mm",
      "Cable Size SQ. MM": "2.50-3.50",
      "Description": "No 4B Special",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004049.jpg"],
    tags: ["terminal", "ring", "brass", "no-4b"],
    applications: ["Automotive", "Electrical Connections"],
  },
  // No 5 Series
  {
    id: "bt-ring-swt004052",
    name: "Ring Series Terminal - No 5 (SWT004052)",
    slug: "ring-terminal-no-5-swt004052",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 5 ring terminal for 4.00-5.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004052",
    specifications: {
      "OD Ø": "16.40 mm",
      "ID Ø": "9.60 mm",
      "Cable Size SQ. MM": "4.00-5.00",
      "Description": "No 5",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004052.jpg"],
    tags: ["terminal", "ring", "brass", "no-5"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004053",
    name: "Ring Series Terminal - No 5A (SWT004053)",
    slug: "ring-terminal-no-5a-swt004053",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 5A ring terminal for 3.00-4.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004053",
    specifications: {
      "OD Ø": "16.00 mm",
      "ID Ø": "10.50 mm",
      "Cable Size SQ. MM": "3.00-4.00",
      "Description": "No 5A",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1500 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004053.jpg"],
    tags: ["terminal", "ring", "brass", "no-5a"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004056",
    name: "Ring Series Terminal - No 5A Heavy (SWT004056)",
    slug: "ring-terminal-no-5a-heavy-swt004056",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 5A Heavy ring terminal for 5.00-6.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004056",
    specifications: {
      "OD Ø": "18.75 mm",
      "ID Ø": "10.50 mm",
      "Cable Size SQ. MM": "5.00-6.00",
      "Description": "No 5A Heavy",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004056.jpg"],
    tags: ["terminal", "ring", "brass", "no-5a"],
    applications: ["Automotive", "Electrical Connections"],
  },
  {
    id: "bt-ring-swt004059",
    name: "Ring Series Terminal - No 5A Heavy Special (SWT004059)",
    slug: "ring-terminal-no-5a-heavy-special-swt004059",
    category: "Brass Terminal",
    subcategory: "Ring Series",
    description: "No 5A Heavy Special ring terminal for 5.00-6.00 sq mm cable. High conductivity brass construction.",
    partNumber: "SWT004059",
    specifications: {
      "OD Ø": "18.40 mm",
      "ID Ø": "10.00 mm",
      "Cable Size SQ. MM": "5.00-6.00",
      "Description": "No 5A Heavy Special",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1000 Cut-1000",
    },
    images: ["/products/brass-terminals/ring-series/SWT004059.jpg"],
    tags: ["terminal", "ring", "brass", "no-5a"],
    applications: ["Automotive", "Electrical Connections"],
  },
];
